import { render, staticRenderFns } from "./StudentUnitPerformance.vue?vue&type=template&id=3dc97df1&scoped=true&"
import script from "./StudentUnitPerformance.vue?vue&type=script&lang=js&"
export * from "./StudentUnitPerformance.vue?vue&type=script&lang=js&"
import style0 from "./StudentUnitPerformance.vue?vue&type=style&index=0&id=3dc97df1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc97df1",
  null
  
)

component.options.__file = "StudentUnitPerformance.vue"
export default component.exports